import BankStatement from './BankStatement';

export default BankStatement;
